module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09K1WVHN2.bccac3ff.jpg";